import { AssetListAsset, AssetRenderingProps } from 'src/@types/assets';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { WRAPPED_SOL_MINT } from '@drift-labs/sdk';
import { useMemo } from 'react';
import useWalletBalancesStore from 'src/stores/useWalletBalancesStore';

export const useWalletAssets = (
	assetList: AssetListAsset[]
): AssetRenderingProps[] => {
	const solBalance = useDriftStore((s) => s.wallet.currentSolBalance);
	const walletBalances = useWalletBalancesStore((s) => s.balances);

	const assetBalances = useMemo(
		() =>
			assetList.map((asset) => {
				if (asset.mint === WRAPPED_SOL_MINT.toBase58()) {
					return solBalance.toNum();
				}
				return walletBalances[asset.ticker]?.base.toNum() ?? 0;
			}),
		[assetList, solBalance, walletBalances]
	);

	return useMemo(
		() =>
			assetBalances.map((balance, index) => {
				return {
					...assetList[index],
					uiAmount: balance ?? 0,
				};
			}),
		[assetBalances, assetList]
	);
};
